module.exports = "/_next/static/images/ac924016b2e28234f0f70fc8070f8e81-woman-using-cellphone@2x.jpg";